(function () {
  function qs(selector, root) { return (root || document).querySelector(selector); }
  function qsa(selector, root) { return Array.prototype.slice.call((root || document).querySelectorAll(selector)); }

  qsa('[data-announcement-close]').forEach(function (button) {
    button.addEventListener('click', function () {
      var bar = button.closest('.announcement-bar');
      if (!bar) return;
      bar.style.height = bar.offsetHeight + 'px';
      bar.style.overflow = 'hidden';
      bar.style.transition = 'height .3s ease, opacity .3s ease, padding .3s ease';
      requestAnimationFrame(function () {
        bar.style.height = '0';
        bar.style.opacity = '0';
        bar.style.paddingTop = '0';
        bar.style.paddingBottom = '0';
      });
      setTimeout(function () { bar.remove(); }, 320);
      setTimeout(function () { window.dispatchEvent(new Event('resize')); }, 340);
    });
  });

  var nav = qs('.nav');
  function updateMobileMenuOffset() {
    var announcement = qs('.announcement-bar');
    var mobileMenu = qs('.mobile-menu');
    var offset = (announcement ? announcement.offsetHeight : 0) + (nav ? nav.offsetHeight : 0);
    document.documentElement.style.setProperty('--mobile-menu-top', offset + 'px');
    if (mobileMenu) {
      mobileMenu.style.setProperty('--mobile-menu-top', offset + 'px');
    }
  }
  if (nav) {
    var onScroll = function () { nav.classList.toggle('scrolled', window.scrollY > 80); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
  window.addEventListener('resize', updateMobileMenuOffset, { passive: true });
  window.addEventListener('orientationchange', updateMobileMenuOffset);
  updateMobileMenuOffset();

  var hamburger = qs('.hamburger');
  var mobileMenu = qs('#mobile-menu');
  if (hamburger && mobileMenu && mobileMenu.dataset.mobileMenuBound !== 'true') {
    mobileMenu.dataset.mobileMenuBound = 'true';
    hamburger.addEventListener('click', function () {
      updateMobileMenuOffset();
      var open = hamburger.classList.toggle('open');
      mobileMenu.classList.toggle('open', open);
      document.body.classList.toggle('menu-open', open);
      hamburger.setAttribute('aria-expanded', String(open));
    });
    qsa('a', mobileMenu).forEach(function (link) {
      link.addEventListener('click', function () {
        hamburger.classList.remove('open');
        mobileMenu.classList.remove('open');
        document.body.classList.remove('menu-open');
        hamburger.setAttribute('aria-expanded', 'false');
      });
    });
  }

  qsa('[data-search-open]').forEach(function (button) {
    button.addEventListener('click', function () {
      var modal = qs('#SearchModal');
      if (!modal) return;
      modal.classList.add('open');
      modal.setAttribute('aria-hidden', 'false');
      var input = qs('input[type="search"]', modal);
      if (input) input.focus();
    });
  });
  qsa('[data-search-close]').forEach(function (button) {
    button.addEventListener('click', function () {
      var modal = qs('#SearchModal');
      if (!modal) return;
      modal.classList.remove('open');
      modal.setAttribute('aria-hidden', 'true');
    });
  });

  qsa('[data-cart-open]').forEach(function (button) {
    button.addEventListener('click', function () {
      var drawer = qs('#CartDrawer');
      if (!drawer) return;
      drawer.classList.add('open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('drawer-open');
    });
  });
  qsa('[data-cart-close]').forEach(function (button) {
    button.addEventListener('click', function () {
      var drawer = qs('#CartDrawer');
      if (!drawer) return;
      drawer.classList.remove('open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('drawer-open');
    });
  });

  qsa('.hero-carousel').forEach(function (carousel) {
    var track = qs('.carousel-track', carousel);
    var slides = qsa('.carousel-slide', carousel);
    var dots = qsa('.carousel-dot', carousel);
    var prevBtn = qs('.carousel-arrow.prev', carousel);
    var nextBtn = qs('.carousel-arrow.next', carousel);
    if (!track || !slides.length) return;
    var current = 0;
    var autoplay = carousel.dataset.autoplay === 'true';
    var delay = Number(carousel.dataset.delay || 5000);
    var timer = null;
    function goTo(index) {
      current = (index + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + current * 100 + '%)';
      dots.forEach(function (dot, i) {
        dot.classList.toggle('active', i === current);
        dot.setAttribute('aria-selected', String(i === current));
      });
    }
    function next() { goTo(current + 1); }
    function prev() { goTo(current - 1); }
    function start() { if (autoplay) { stop(); timer = setInterval(next, delay); } }
    function stop() { if (timer) clearInterval(timer); timer = null; }
    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); start(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { next(); start(); });
    dots.forEach(function (dot, i) { dot.addEventListener('click', function () { goTo(i); start(); }); });
    var touchStart = 0;
    carousel.addEventListener('touchstart', function (event) { touchStart = event.changedTouches[0].screenX; }, { passive: true });
    carousel.addEventListener('touchend', function (event) {
      var diff = touchStart - event.changedTouches[0].screenX;
      if (Math.abs(diff) > 50) { diff > 0 ? next() : prev(); start(); }
    }, { passive: true });
    carousel.addEventListener('mouseenter', stop);
    carousel.addEventListener('mouseleave', start);
    goTo(0);
    start();
  });

  qsa('.fade-in-up').forEach(function (element) {
    if (!('IntersectionObserver' in window)) {
      element.classList.add('visible');
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    observer.observe(element);
  });

  qsa('.faq-question').forEach(function (button) {
    if (button.dataset.faqBound === 'true') return;
    button.dataset.faqBound = 'true';
    button.addEventListener('click', function () {
      var item = button.closest('.faq-item');
      var open = item.classList.contains('open');
      qsa('.faq-item', item.parentElement).forEach(function (node) {
        node.classList.remove('open');
        var control = qs('.faq-question', node);
        if (control) control.setAttribute('aria-expanded', 'false');
      });
      if (!open) {
        item.classList.add('open');
        button.setAttribute('aria-expanded', 'true');
      }
    });
  });

  qsa('[data-quantity]').forEach(function (wrapper) {
    var input = qs('input', wrapper);
    qsa('button', wrapper).forEach(function (button) {
      button.addEventListener('click', function () {
        var value = Number(input.value || 1);
        var next = button.dataset.quantityAction === 'plus' ? value + 1 : Math.max(1, value - 1);
        input.value = next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  qsa('[data-gallery-thumb]').forEach(function (button) {
    button.addEventListener('click', function () {
      var gallery = button.closest('[data-product-gallery]');
      var main = qs('[data-gallery-main]', gallery);
      var image = qs('img', button);
      if (!main || !image) return;
      main.innerHTML = image.outerHTML;
      qsa('[data-gallery-thumb]', gallery).forEach(function (node) { node.classList.remove('active'); });
      button.classList.add('active');
    });
  });

  qsa('[data-product-form]').forEach(function (form) {
    var variantData = qs('[data-variants-json]', form);
    var select = qs('[name="id"]', form);
    if (!variantData || !select) return;
    var variants = JSON.parse(variantData.textContent);
    var optionInputs = qsa('[data-option-input]', form);
    function updateVariant() {
      var selectedOptions = [];
      optionInputs.forEach(function (input) {
        if ((input.type === 'radio' && input.checked) || input.tagName === 'SELECT') selectedOptions[Number(input.dataset.optionIndex)] = input.value;
      });
      var variant = variants.find(function (item) {
        return item.options.every(function (value, index) { return value === selectedOptions[index]; });
      });
      if (!variant) return;
      select.value = variant.id;
      var submit = qs('[type="submit"]', form);
      if (submit) {
        submit.disabled = !variant.available;
        submit.textContent = variant.available ? submit.dataset.availableText : submit.dataset.soldOutText;
      }
    }
    optionInputs.forEach(function (input) { input.addEventListener('change', updateVariant); });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var search = qs('#SearchModal.open');
    if (search) search.classList.remove('open');
    var drawer = qs('#CartDrawer.open');
    if (drawer) drawer.classList.remove('open');
    if (hamburger && mobileMenu) {
      hamburger.classList.remove('open');
      mobileMenu.classList.remove('open');
    }
    document.body.classList.remove('menu-open', 'drawer-open');
  });
})();
